import { downloadPdf } from '../../common/utils/pdfUtils';
import { fetcher } from '../../http/Fetcher';

export const FORMER_MEMBER_API = '/api/inactive-membership-member';

export async function downloadFormerMemberStatement(
    userId: string,
    yearMonth: string,
): Promise<string> {
    const response: { data: string } = await fetcher({
        method: 'POST',
        endpoint: `${FORMER_MEMBER_API}/users/${userId}/statement`,
        body: JSON.stringify({ yearMonth }),
    });

    const filename = `Fruitful_statement_${yearMonth.substring(0, 7)}.pdf`;
    return await downloadPdf(response, filename);
}

export async function downloadFormerMemberTaxDocument(
    userId: string,
    year: string,
): Promise<string> {
    const response: { data: string } = await fetcher({
        method: 'POST',
        endpoint: `${FORMER_MEMBER_API}/users/${userId}/tax-document`,
        body: JSON.stringify({ year }),
    });

    const filename = `Fruitful_1099_INT_${year}.pdf`;
    return await downloadPdf(response, filename);
}
